module.exports = __webpack_public_path__ + "static/media/ControlRoomActive.37be545d.png";